import { Box } from '@mui/material';
import Header from '@parkdna/ui/Header';
import { Outlet } from 'react-router-dom';

export interface SceneLayoutProps {
  title: string;
  subtitle: string;
}

const SceneLayout = ({ title, subtitle }: SceneLayoutProps) => {
  return (
    <Box
      sx={{
        p: {
          xs: 0.7,
          md: 2,
        },
      }}
      display="flex"
      flexDirection="column"
    >
      <Header title={title} subtitle={subtitle} />
      <Outlet />
    </Box>
  );
};

export default SceneLayout;
